import DataBinder from "../DataBinder.js";
import SwapPage from "../SwapPage.js";
import Items from "../Items.js";


export default class GameModeController {

  constructor(app) {
    this.app = app;
    this.items = app.items;
  }

  show(path, model) {
     model = this.getModel();

    //get page
    let pageId = path.split("/")[0];

    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);

    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);
  }
  getModel() {
    const app = this.app;
    const userdata = app.userdata;
    const achievement = app.achievements;
    const allItems = this.items.allItems;


    let coins = userdata.coins || 0;
    let fullVersion = userdata.fullVersion;
    let ownedItems = userdata.items || [];
    let items = allItems.filter(i => i.type === "GameMode");
    let itemsModel = items.map((i) => {
      let owned = ownedItems.includes(i.name);
      if (i.cost === 0 || fullVersion == true) owned = true;
      return {
        name: i.name,
        icon: i.icon,
        title: i.title,
        description: i.description,
        owned: owned,
        locked: !owned,
        cost: i.cost,
        url: i.url,
        background: i.background
      };
    });
    
    let model = {
      coins: coins,
      items: itemsModel
    }


    return model;

  }
  buyItem(name){
    let bought = this.app.buyItem(name);
    if (bought) this.app.navigate("ComputerMenu");
  }
}